import { req } from '../../@api/request';

export default class NewsService {
  static list = async (limit: number, page: number) => {
    const result = await req.get(`/news/list?limit=${limit}&page=${page}`);
    return result.data;
  };
}
